import { renderPage } from "renderPage"
import { ClubProductIndexPage } from "./Page"

renderPage({ component: ClubProductIndexPage })
